import React, { useEffect, useRef, useState } from 'react';
import './Assistant.css';
import { Text } from 'grommet';
import AiChat from '../../../../../../../assets/ai_assistant.svg';
import ChatBox from './ChatBox/ChatBox';
import minimize from '../../../../../../../assets/collapse_content.svg';
import minimize_hover_state from '../../../../../../../assets/collapse_content_white.svg';
import { observer } from 'mobx-react';
import { useStore } from '../../../../../../../Hooks/useStore';
import PromptInput from './component/promptInput';
import { Auth } from 'aws-amplify';
import { BedrockRuntimeClient, ConverseCommand, InvokeModelCommand } from "@aws-sdk/client-bedrock-runtime";
import { useParams } from 'react-router-dom';
import AIChatFeed from './component/AIChatFeed/AIChatFeed';
import createFlightService from '../../../IAM/Users/CreateFlight/create-flight.service';
import { MedicalEmergencyHelper } from '../../../../../../../util/medical-emergency/MedicalEmergencyHelper';
import MedicalEmergencyService from '../../../../../../../services/medical-emergency/medical-emergency.service';

const Assistant = observer(({ isDisable }) => {
    const { medicalEmergencyId } = useParams();
    const chatContainerRef = useRef(null);
    const { rootStore } = useStore();
    const [currentCrewLocation, setCurrentCrewLocation] = useState({});

    function addDataToLocalStorage(id, newData) {
        // Retrieve the existing data from localStorage
        const existingData = JSON.parse(localStorage.getItem('chat')) || [{[id]: [{you: '', response: "Hello, I’m your AI assistant. How can I assist you today?", time: new Date()}]}];
    
        // Find the index of the object with the given id
        const dataIndex = existingData.findIndex(item => item.hasOwnProperty(id));
    
        if (dataIndex !== -1) {
            // If the id exists, add the new data to the inner array
            existingData[dataIndex][id].push(newData);
        } else {
            existingData.push({ [id]: [newData] });
        }
    
        // Save the updated data back to localStorage
        localStorage.setItem('chat', JSON.stringify(existingData));
        setTimeout(() => {
            changeScrollPosition();
        },100);
    };

    async function findCrew () {
        const medicalEmergencyHelper = new MedicalEmergencyHelper();
        let cognitoUserIdCrew = await medicalEmergencyHelper.findCrewName(medicalEmergencyId);
        const currentLocation = await MedicalEmergencyService.getCrewLocation(cognitoUserIdCrew);
        setCurrentCrewLocation(currentLocation)
        return currentLocation
      }
    
      useEffect(()=>{
        findCrew();
      },[])

      const contextualizationQuery = async() => {
        const flight = await createFlightService.getOrganization(rootStore.emsStore.getSelectedEmergency.organizationId);
        return (
            `The passenger, ${rootStore.emsStore.getPassenger?.name }, is experiencing a medical emergency on flight ${flight.name} (tail number: ${rootStore.emsStore.getSelectedEmergency?.flightPrimaryKey?.split(";")[0]}). The passenger's details are as follows: \n
              -Age: ${rootStore.emsStore.getPassenger?.age?.toString()}, \n
              -Gender: ${rootStore.emsStore.getPassenger?.gender}, \n
              -Complaints: ${rootStore.emsStore.getSelectedEmergency?.symptoms}, \n
              -Current date and time : ${new Date()}, \n
              -Patient's current status: ${rootStore.emsStore.getSelectedEmergency?.isPatientConscious?"conscious":"not conscious"}, \n
              The flight has ${rootStore.emsStore.getFlightLandedStatus?"landed":"not landed yet"},and diversion is ${rootStore.emsStore.getDiversionStatus? "required":"not currently required"}. \n The Flight is currently at: \n -Latitude: ${currentCrewLocation.latitude} \n -Longitude: ${currentCrewLocation.longitude}`
        )
      };


    const onQuerySend = async (query) => {
        rootStore.assistantStore.setLoading(true);
        const client = new BedrockRuntimeClient({
            region: "us-east-1",
            credentials:  await Auth.currentCredentials(),
          });
          
          const contextQuery = await contextualizationQuery();
          try {
            const command = new InvokeModelCommand({
              modelId: "ai21.jamba-1-5-mini-v1:0",
              accept: 'application/json',
              contentType: 'application/json',
              body: JSON.stringify({
                max_tokens: 1000,
                temperature: 0,
                messages: [
                    {
                      role: 'user',
                      content: contextQuery,
                    },
                    {
                      role: 'user',
                      content: query
                    }
                  ],
              }),
            });
            changeScrollPosition();
            const response = await client.send(command);
            console.log("responseresponseresponse", response);
      
             // Convert byte array to string
            const byteArray = response.body;
            const jsonString = String.fromCharCode(...byteArray);
           // Parse the string into a JSON object
            const jsonResponse = JSON.parse(jsonString);
            console.log("jsonResponse",jsonResponse?.choices?.[0]?.message);
            const chatObj = {
                you: query,
                response: jsonResponse?.choices?.[0]?.message.content,
                time: new Date()
            };
            addDataToLocalStorage(medicalEmergencyId,chatObj);
            rootStore.assistantStore.setAiResponse(jsonResponse?.choices?.[0]?.message.content);
          } catch (error) {
            console.error('Error invoking model:', error);
          } finally {
            rootStore.assistantStore.setLoading(false);
            rootStore.assistantStore.setPrompt("");
          }
    }

    const changeScrollPosition = () => {
        const chatContainer = chatContainerRef.current;
        if (chatContainer) {
          chatContainer.scrollTop = chatContainer.scrollHeight;
        }
    }
    useEffect(() => {
        changeScrollPosition();
      }, [rootStore.assistantStore.getShowChatBot]);

          useEffect(() => {
        (async () => {
            // Retrieve the existing data from localStorage
            const existingData = JSON.parse(localStorage.getItem('chat')) || [];

            // Find the index of the object with the given id
            const dataIndex = existingData.findIndex(item => item.hasOwnProperty(medicalEmergencyId));

            if (dataIndex !== -1) {
                // If the id exists, add the new data to the inner array
                rootStore.assistantStore.setTalkHistory(existingData[dataIndex][medicalEmergencyId]);
            } else {
                // If the id doesn't exist, create a new entry
                rootStore.assistantStore.setTalkHistory([]);
            }
        })();

        return () => {
            rootStore.assistantStore.setExpand(false);
        }
    },[rootStore.assistantStore.setAiResponse,rootStore.assistantStore.getPrompt]);

    const onChatBotClick = () => {
        rootStore.assistantStore.setShowChatBot(true);
    }
    return (
        <>
            <div className='assistant-btn' style={{opacity: isDisable ? 0.6 : 1,cursor: isDisable ? 'not-allowed' : "pointer",pointerEvents: isDisable ? "none" : "auto"}}>
                <div className='chatbot-button' onClick={onChatBotClick}>
                    <div className='ai-chat-greet'>
                        <p>Hi! I am <Text>ASH</Text></p>
                        <p>your AI Assistant</p>
                    </div>
                    <div className='ai-chat-icon'>
                        <img src={AiChat} alt='AI Assistant Icon'/>
                    </div>
                </div>
                {
                    rootStore.assistantStore.getShowChatBot ?
                    (   <>
                            <div className='ai-box-overlay'></div>
                            <div className='ai-chat-box'>
                                <div className='ai-chat-header'>
                                    <div className='left-header'>
                                        <img src={AiChat} alt='AI Assistant Icon'/>
                                        <div className='ai-chat-greet'>
                                            <p>Chat with <Text>ASH</Text></p>
                                            <p>AI Assistant</p>
                                        </div>
                                    </div>
                                    <div className='right-header'>
                                        <div onClick={() => {rootStore.assistantStore.setShowChatBot(false);rootStore.assistantStore.setExpand(false);}} className='control-icon' onMouseEnter={() => rootStore.assistantStore.setExpand(true)} onMouseLeave={() => rootStore.assistantStore.setExpand(false)}>
                                            <img src={rootStore.assistantStore.getExpand ? minimize_hover_state : minimize} alt='expand' />
                                        </div>
                                        <div className='ai-tooltip'>
                                            <div className='ai-close-tooltip'>Collapse</div>
                                        </div>
                                    </div>
                                </div>
                                <div className='ai-chat-content'>
                                    <p ref={chatContainerRef}>
                                        <AIChatFeed loading={rootStore.assistantStore.getLoading} onSend={onQuerySend} data={rootStore.assistantStore.getTalkHistory} />
                                    </p>
                                    <div>
                                        <PromptInput loading={rootStore.assistantStore.getLoading} onSend={onQuerySend} />
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                    :
                    null
                }
            </div>
        </>

    );
});

export default Assistant;
